module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/reporte-cxc/modal-intereses-moratorios/modal-intereses-moratorios.component.scss
// module id = ./src/app/components/reporte-cxc/modal-intereses-moratorios/modal-intereses-moratorios.component.scss
// module chunks = main